import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily?: string; error?: string | null }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      phoneNumberContainer: {
        display: 'flex',
        padding: '0px 40px',
        background: 'transparent',
        borderRadius: '50px',
        border: props.error ? '1px solid #FF1919' : '1px solid #DDDDDD',
        boxShadow: 'none',
        alignItems: 'center',
        '&:hover': {
          boxShadow: `inset 0 0 10px 0 rgb(0 0 0 / 15%)`
        },
        [theme.breakpoints.down('lg')]: {
          minWidth: '480px'
        }
      },
      countryCode: {
        height: '100%',
        minHeight: '104px',
        alignContent: 'center',
        minWidth: '170px',
        background: 'transparent',
        fontSize: '32px',
        fontFamily: props.fontFamily,
        fontWeight: 400,
        '& > .MuiSelect-select:focus': {
          backgroundColor: 'transparent'
        }
      },
      phoneNumber: {
        height: '100%',
        minHeight: '116px',
        maxWidth: '80%',
        justifyContent: 'center',
        padding: '12px 24px',
        fontWeight: 600,
        fontFamily: props.fontFamily,
        fontSize: '40px',
        background: 'transparent',
        '& > * > input': {
          minHeight: '42px',
          fontSize: '40px',
          fontWeight: 600,
          caretColor: 'transparent',
          [theme.breakpoints.down('lg')]: {
            fontSize: '30px',
            minHeight: '54px'
          }
        },
        [theme.breakpoints.down('lg')]: {
          padding: '6px 12px'
        }
      },
      flagImage: {
        height: '40px',
        width: '60px',
        padding: '4px 4px 4px 4px',
        marginRight: '8px'
      },
      menuItem: {
        height: '80px',
        width: '100%',
        margin: '4px 4px 4px 4px',
        fontFamily: props.fontFamily,
        fontSize: '32px',
        fontWeight: 400
      },
      selectedItem: {
        height: '80px',
        width: '100%',
        margin: '1px 1px 1px 1px',
        fontFamily: props.fontFamily,
        fontSize: '40px',
        fontWeight: 600,
        [theme.breakpoints.down('lg')]: {
          fontSize: '30px'
        }
      },
      selectedImage: {
        height: '40px',
        width: '60px',
        padding: '1px 1px 1px px',
        marginRight: '8px'
      },
      inputLabel: {
        fontFamily: props.fontFamily,
        fontWeight: 600,
        fontSize: '40px',
        padding: '0px 22px',
        color: '#2A2A2A',
        marginBottom: '10px'
      },
      '@global': {
        '.MuiPopover-paper::-webkit-scrollbar-track': {
          backgroundColor: '#D8D8D8',
          padding: '20px 0px'
        },
        '.MuiPopover-paper::-webkit-scrollbar': {
          width: '43px',
          border: '1px solid grey',
          background: 'transparent',
          borderRadius: '25px'
        },
        '.MuiPopover-paper::-webkit-scrollbar-button': {
          height: '40px',
          width: '43px',
          background: 'transparent',
          borderRadius: '20px'
        },
        '.MuiPopover-paper::-webkit-scrollbar-thumb': {
          borderRadius: '23px',
          background: 'linear-gradient(-45deg,#22282E,#22282E,#707070)'
        },

        '.MuiPopover-paper::-webkit-scrollbar-button:single-button': {
          backgroundColor: '#D8D8D8',
          display: 'block',
          backgroundSize: '20px',
          backgroundRepeat: 'no-repeat'
        },

        /* Up */
        '.MuiPopover-paper::-webkit-scrollbar-button:single-button:vertical:decrement': {
          borderRadius: '5px 5px 0 0',
          height: '36px',
          width: '36px',
          backgroundPosition: 'center',
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(42 42 42)'><polygon points='50,00 0,50 100,50'/></svg>\")"
        },

        '.MuiPopover-paper::-webkit-scrollbar-button:single-button:vertical:decrement:hover': {
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(42 42 42)'><polygon points='50,00 0,50 100,50'/></svg>\")"
        },

        '.MuiPopover-paper::-webkit-scrollbar-button:single-button:vertical:decrement:active': {
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(42 42 42)'><polygon points='50,00 0,50 100,50'/></svg>\")"
        },

        /* Down */
        '.MuiPopover-paper::-webkit-scrollbar-button:single-button:vertical:increment': {
          borderRadius: '0 0 5px 5px',
          height: '36px',
          width: '36px',
          backgroundPosition: 'center',
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(42 42 42)'><polygon points='0,0 100,0 50,50'/></svg>\")"
        },

        '.MuiPopover-paper::-webkit-scrollbar-button:single-button:vertical:increment:hover': {
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(42 42 42)'><polygon points='0,0 100,0 50,50'/></svg>\")"
        },

        '.MuiPopover-paper::-webkit-scrollbar-button:single-button:vertical:increment:active': {
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(42 42 42)'><polygon points='0,0 100,0 50,50'/></svg>\")"
        }
      }
    })
  );
